import React, { useEffect, useState } from "react";
import "./Autocomplete.css";
import "./Aroundme.css";
import conf from "../config.json";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrosshairs } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const AroundMe = ({
  setLocationHooks,
  map,
  radius,
  marker,
  geoLocate,
  setRadius,
  setMarker,
  setGeoLocate,
  setKeyword,
  keyword,
}) => {
  useEffect(() => {
    if (!geoLocate && marker && radius) {
      marker.setMap(null);
      radius.setMap(null);
      setMarker(null);
      setRadius(null);
    }
  }, [geoLocate]);
  const getPosition = async (event) => {
    if (!geoLocate) {
      try {
        const { data } = await axios.get(
          `https://api.woosmap.com/geolocation/position?key=${conf.woosmapLoadOptions.publicKey}`
        );
        if (data.latitude) {
          const position = { lat: data.latitude, lng: data.longitude };
          var circleOptions = {
            strokeColor: "#34b3e5",
            strokeOpacity: 0.6,
            strokeWeight: 2,
            fillColor: "#34b3e5",
            fillOpacity: 0.35,
            map: map,
            center: position,
            radius: 700,
          };

          var centerCircleOptions = {
            strokeColor: "#34B3E5",
            strokeOpacity: 0,
            strokeWeight: 2,
            fillColor: "#34B3E5",
            fillOpacity: 1,
            map: map,
            center: position,
            radius: 50,
          };

          const radius = new woosmap.map.Circle(circleOptions);

          const marker = new woosmap.map.Circle(centerCircleOptions);

          map.flyTo({
            center: position,
            zoom: 13,
            duration: 800, // optional animation duration in ms
          });

          setGeoLocate(true);
          setMarker(marker);
          setRadius(radius);
          setLocationHooks({ ...position });
          if (keyword !== "") {
            setKeyword("");
          }
          return;
        }
      } catch (err) {
        console.log(err);
      }
    }
    marker.setMap(null);
    radius.setMap(null);
    setMarker(null);
    setRadius(null);
    setGeoLocate(false);
  };

  return (
    <div className="control  has-icons-right">
      <input
        className={`input is-small ${geoLocate ? "geolocate-active" : ""}`}
        type="email"
        placeholder="Intorno a te"
        disabled={true}
      />

      <span
        className={`icon is-large is-right`}
        onClick={(event) => getPosition(event, geoLocate, setGeoLocate, map)}
      >
        <FontAwesomeIcon icon={faCrosshairs} color={geoLocate ? "red" : ""} />
      </span>
    </div>
  );
};

export default AroundMe;
